export const LOAD_CULTURES = 'load_cultures';
export const CULTURES_LOADED = 'cultures_loaded';
export const SYNC_FAILED = 'culture_sync_error';
export const RESET_CULTURES = 'reset_cultures';
